import { useNavigate } from 'react-router-dom'

let navigator: ReturnType<typeof useNavigate> | null = null

export const setNavigator = (nav: any) => {
  navigator = nav
}

export const navigate = (to: string, options?: any) => {
  if (navigator) {
    navigator(to, options)
  }
}
